import { useTheme } from '@mui/material';
import { TableV1 } from '../../../components/Table/TableV1';
import {
  getCoreRowModel,
  getExpandedRowModel,
  getFacetedUniqueValues,
  getFilteredRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from '@tanstack/react-table';
import { useState } from 'react';
import { TableSkeletonLoader } from '../../../components/SkeletonLoader/Table.SkeletonLoader';
import { useDealOwnerDealsWithTimeLogs } from '../../../queries/hooks/useDealOwnerDealsWithTimeLogs';
import { useOpChargeSummaryTableColumns } from '../hooks/useOpChargeSummaryTableColumns';
import { OpChargeSummarySubTable } from './OpChargeSummarySubTable';

interface Props {
  selectedYear: number;
  selectedMonth: number;
}

export const OpChargeSummaryTable = ({ selectedYear, selectedMonth }: Props) => {
  const { colors } = useTheme();
  const [sorting, setSorting] = useState<SortingState>([]);

  const { data, isLoading } = useDealOwnerDealsWithTimeLogs(selectedYear, selectedMonth);
  const columns = useOpChargeSummaryTableColumns();

  const table = useReactTable({
    data: data ?? [],
    columns,
    state: {
      sorting,
    },
    enableSorting: true,
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getFacetedUniqueValues: getFacetedUniqueValues(),
    getRowCanExpand: (row) => !!row.original?.dealTimeLogs?.length,
    getExpandedRowModel: getExpandedRowModel(),
    meta: (row) => {
      return {
        isExpanded: row.original.ops,
      };
    },
  });

  if (isLoading) return <TableSkeletonLoader />;

  return (
    <div>
      <TableV1
        table={table}
        height='auto'
        isLastColumnSticky={false}
        wrapperStyle={{
          maxHeight: 'calc(100vh - 180px)',
          overflowX: 'scroll',
          border: `1px solid ${colors.border.default}`,
        }}
        subComponent={OpChargeSummarySubTable}
      />
    </div>
  );
};
